<template>
    <div class="comment-question">
        <label><slot name="label"></slot></label>
        <textarea id="" v-model="currentValue" @focus="focus"></textarea>
        {{ error }}
    </div>
</template>
<script>
export default {
    name: "comment-question",
    props: {
        value: {
            type: String,
            default: "",
        },
    },
    data: function () {
        return {
            currentValue: this.value,
            error: null,
            valid: null,
        };
    },
    methods: {
        setValue: function (value) {
            if (this.currentValue == value) {
                this.currentValue = null;
            } else {
                this.currentValue = value;
            }
            this.$emit("change", this.currentValue);
        },
        focus: function () {
            this.$emit("focus", this);
        },
        getValue: function () {
            return this.currentValue;
        },
        isValid: function () {
            return true;
        },
        isNull: function () {
            if (!this.currentValue) {
                return true;
            }
            return false;
        },
    },
    watch: {
        currentValue(newValue) {
            this.$emit("change", newValue);
        },
    },
};
</script>
